//helpers
import DTM, { PAGE_TYPE, EVENTS } from 'shared/helpers/DTM';
import {
  CHANNEL,
  EVENT_TYPES,
  SEARCH_TYPE,
} from 'shared/layouts/Listing/Desktop/components/AnalyticsV2/constants';
import { onClickInteraction } from 'shared/layouts/Listing/components/Analytics/helpers';
import NFA from 'shared/helpers/analytics/NFAnalytics';
import {
  getUndefinedIfNotValid,
  pushRetinaDataInDatalayer,
} from 'shared/helpers/analytics/helpers';

//types
import { IMapOfString } from 'global';
import { SearchPageLoadProps, PageLoadProps, OfferPageLoadProps } from './types';
import { PLP_INTERACTION } from 'shared/helpers/analytics/constants/plpEvents';

//constants
import { PLP_EVENTS } from 'shared/helpers/analytics/constants/plpEvents';
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';

export const onClearFiltersClick = () => {
  DTM.track(EVENT_TYPES.CLEAR_ALL_CLICK);
};

export const onProductClick = (item: Listing.IProduct) => {
  onClickInteraction(item.type === 'tiptile' ? PLP_INTERACTION.TIP_TILE : PLP_INTERACTION.PRODUCT);
  if (item.type === 'tiptile') return;

  DTM.track(EVENT_TYPES.PRODUCT_CARD_CLICK, {
    product_id: item.id,
    parentSku: item.sku,
    price: item.price,
    salePrice: item.discountedPrice ? item.discountedPrice : item.price,
    productName: item.subTitle,
    productBrand: item.title,
    productPosition: item.lcp ? item.lcp + 1 : undefined,
  });
};

export const onSearchPageLoad = ({
  title,
  impressiveProducts = '',
  queryExpansionTerm,
  queryExpansionType,
  guidesAvailable,
  isPriceReveal,
  merchandisingDetails,
  pagePayload,
}: SearchPageLoadProps) => {
  const data: IMapOfString = {};

  const {
    is_hybrid_page: isHybridPage,
    has_pinned_products: hasPinnedProducts,
    has_tiptiles: hasTiptiles,
    has_banners: hasBanners,
  } = merchandisingDetails;

  data.isHybridPage = isHybridPage;
  data.hasPinnedProducts = hasPinnedProducts;
  data.hasTiptiles = hasTiptiles;
  data.hasBanners = hasBanners;
  data.searchTerm = title;
  data.channel = CHANNEL;
  data.pagename = `${CHANNEL}: Search`;
  data.eventName = EVENTS.SEARCH;
  data.pagetype = PAGE_TYPE.SEARCH;
  data.searchtype = SEARCH_TYPE;
  data.productimpressions = impressiveProducts;
  data.queryExpansionTerm = queryExpansionTerm;
  data.queryExpansionType = queryExpansionType;
  if (guidesAvailable !== undefined) {
    data.guidesAvailable = guidesAvailable;
  }
  data.isPriceReveal = isPriceReveal.toString();
  data.rumPageType = 'PLP_DESKTOP_V2';

  pushRetinaDataInDatalayer({ plpSearchTerm: title });

  NFA.track({
    type: TRACK_TYPE.PAGELOAD,
    event: PLP_EVENTS.SEARCH_PAGELOAD,
    data: pagePayload,
    dtmData: data,
  });
};

export const onOfferPageLoad = ({ params, isPriceReveal, productId }: OfferPageLoadProps) => {
  const data: IMapOfString = {};
  data.pagetype = PAGE_TYPE.LISTING;
  data.eventName = EVENTS.LISTING;
  data.channel = CHANNEL;
  data.isOffer = true;
  data.activeOfferId = productId;

  data.guidesAvailable = params.guidesAvailable;
  data.isPriceReveal = isPriceReveal.toString();
  data.rumPageType = 'PLP_DESKTOP_V2';

  DTM.onPageLoad(data);
};

export const onPageLoad = ({
  title,
  isBrand,
  params,
  isPriceReveal,
  merchandisingDetails,
  pagePayload,
  categoryPageData,
}: PageLoadProps) => {
  const {
    is_hybrid_page: isHybridPage,
    has_pinned_products: hasPinnedProducts,
    has_tiptiles: hasTiptiles,
    has_banners: hasBanners,
  } = merchandisingDetails;

  const data: IMapOfString = {};
  data.pagetype = PAGE_TYPE.LISTING;

  data.channel = CHANNEL;
  data.brand = title;
  data.category = title;
  data.isBrand = isBrand;
  data.isHybridPage = isHybridPage;
  data.hasPinnedProducts = hasPinnedProducts;
  data.hasTiptiles = hasTiptiles;
  data.hasBanners = hasBanners;

  let category_path = params.routeParams
    ? `${CHANNEL}:${params.routeParams.replace(/\//g, ':')}`
    : `${CHANNEL}:op:${params.id}`;

  if (params.categoryId) {
    data.categoryId = params.categoryId;
  }

  data.pagename = `${category_path}`;
  data.category_description = `${category_path}`;
  data.designer_name = `${category_path}`;
  data.eventName = EVENTS.LISTING;
  data.pagetype = PAGE_TYPE.LISTING;
  // @ts-ignore
  data.guidesAvailable = params.guidesAvailable;
  data.isPriceReveal = isPriceReveal.toString();
  data.rumPageType = 'PLP_DESKTOP_V2';

  pushRetinaDataInDatalayer({ plpCategoryId: params.categoryId, plpCategoryName: title });

  NFA.track({
    type: TRACK_TYPE.PAGELOAD,
    event: PLP_EVENTS.CATEGORY_PAGELOAD,
    data: {
      ...pagePayload,
      ...categoryPageData,
      PLPId: params.id,
      isBrandListing: isBrand,
      categoryId: getUndefinedIfNotValid(params.categoryId) || params.id,
    },
    dtmData: data,
  });
};

export const onFiltersUpdated = () => {
  DTM.track(EVENT_TYPES.FILTERS_UPDATED);
};
